import * as yup from 'yup'
import { DataTableHtmlFormatter } from '../../../../../Component/Model/helpers';

const stakeholderMaxLength: number = 100;
const responsibilityMaxLength: number = 600;
const frequencyMaxLength: number = 600;

export const monitoringProgressSchema = yup.object({
    stakeholder: yup.string()        
        .required('Stakeholder is required')
        .test('stakeholderLengthTest', `Stakeholder description is too long`, value => {
            if (!value) {
                return true;
            }
            return DataTableHtmlFormatter(value, '').length <= stakeholderMaxLength;
        }),

    responsibility: yup.string()
        .required('Role/Responsibility is required')
        .test('responsibilityLengthTest', `Role/Responsibility description is too long`, value => {
            if (!value) {
                return true;
            }
            return DataTableHtmlFormatter(value, '').length <= responsibilityMaxLength;
        }),

    frequency: yup.string()
        .required('Frequency is required')
        .test('frequencyLengthTest', `Frequency description is too long`, value => {
            if (!value) {
                return true;
            }
            return DataTableHtmlFormatter(value, '').length <= frequencyMaxLength;
        })
})
